import api, { getCurrentMode } from "../utils/api";

const pinnedBoardService = {
  /**
   * Pin a board to user's dashboard
   * @param {string} boardId - Board ID to pin
   * @returns {Promise<Object>} - Response data
   */
  async pinBoard(boardId) {
    try {
      const response = await api.put("/users/pinboard", { boardId });
      return response.data;
    } catch (error) {
      console.error("Error pinning board:", error);
      throw error;
    }
  },

  /**
   * Unpin a board from user's dashboard
   * @param {string} boardId - Board ID to unpin
   * @returns {Promise<Object>} - Response data
   */
  async unpinBoard(boardId) {
    try {
      const response = await api.put("/users/unpinboard", { boardId });
      return response.data;
    } catch (error) {
      console.error("Error unpinning board:", error);
      throw error;
    }
  },

  /**
   * Get user's pinned boards
   * @returns {Promise<Array>} - Array of pinned boards
   */
  async getPinnedBoards() {
    try {
      const response = await api.get("/users/pinnedboards");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching pinned boards:", error);
      throw error;
    }
  },

  /**
   * Check if a board is pinned by the current user
   * @param {string} boardId - Board ID to check
   * @param {Array} pinnedBoards - Array of pinned board IDs
   * @returns {boolean} - True if board is pinned
   */
  isBoardPinned(boardId, pinnedBoards) {
    if (!pinnedBoards || !Array.isArray(pinnedBoards)) return false;
    return pinnedBoards.some(
      (pinnedBoard) => pinnedBoard._id === boardId || pinnedBoard.id === boardId
    );
  },
};

export default pinnedBoardService;
